import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import ClientWeeklyMealPlanView from "@/components/trainer/ClientWeeklyMealPlanView";

export default function ClientWeeklyMealModal({ client, open, onOpenChange }) {
  if (!client) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto w-[calc(100%-2rem)] rounded-xl">
        <DialogHeader>
          <DialogTitle className="font-display">Weekly Meal Plan — {client.full_name}</DialogTitle>
        </DialogHeader>
        <ClientWeeklyMealPlanView clientId={client.id} />
      </DialogContent>
    </Dialog>
  );
}